import {UPDATEROW} from '../constants';
const INITIAL_STATE = {};
export default (state = INITIAL_STATE,action)=>{
  switch(action.type){
    case UPDATEROW:
      return action.payload;
    default:
      return state;
  }
}
